var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm._v(" " + _vm._s(_vm.descrip) + " "),
    _vm.viewMore && _vm.description.length > _vm.textLength
      ? _c(
          "span",
          {
            staticClass: "pointer cust-link cursor-pointer",
            on: {
              click: function ($event) {
                _vm.viewMore = false
              },
            },
          },
          [_vm._v("View more")]
        )
      : _vm._e(),
    !_vm.viewMore && _vm.description.length > _vm.textLength
      ? _c(
          "span",
          {
            staticClass: "pointer cust-link cursor-pointer",
            on: {
              click: function ($event) {
                _vm.viewMore = true
              },
            },
          },
          [_c("br"), _vm._v("View less")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }